import { Icon } from '@blueprintjs/core'
import * as React from 'react'

export const SortDirectionIndicator = ({ header, sortKey }) => {
  const parts = sortKey.split('.')
  const key = parts[0]
  const dir = parts[1]

  const iconArrow = React.useMemo(() => {
    return header === key
  }, [header, key])

  return <Icon icon={dir === 'asc' && iconArrow ? 'caret-up' : 'caret-down'} />
}
